"use strict";

exports.__esModule = true;
exports.TreeViewElement = TreeViewElement;
var _react = _interopRequireDefault(require("react"));
var _reactSortableTree = _interopRequireDefault(require("react-sortable-tree"));
require("react-sortable-tree/style.css");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getCollapseBgImage = function getCollapseBgImage(color) {
  return "data:image/svg+xml;base64," + btoa("<svg style=\"fill: " + color + "\" xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 16 16' enable-background='new 0 0 16 16' xml:space='preserve'>\n\" +\n  \"<g id='caret_down_3_'>\n\" +\n  \"\t<g>\n\" +\n  \"\t\t<path fill-rule='evenodd' clip-rule='evenodd' d='M12,6.5C12,6.22,11.78,6,11.5,6h-7C4.22,6,4,6.22,4,6.5    c0,0.13,0.05,0.24,0.13,0.33c0,0,0,0,0,0l3.5,4l0,0C7.72,10.93,7.85,11,8,11s0.28-0.07,0.37-0.17l0,0l3.5-4l0,0    C11.95,6.74,12,6.63,12,6.5z'/>\n\" +\n  \"\t</g>\n\" +\n  \"</g>\n\" +\n  \"</svg>");
};
var getExpandBgImage = function getExpandBgImage(color) {
  return "data:image/svg+xml;base64," + btoa("<svg style=\"fill: " + color + "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\">\n<g id=\"caret_right_3_\">\n\t<g>\n\t\t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11,8c0-0.15-0.07-0.28-0.17-0.37l0,0l-4-3.5l0,0C6.74,4.05,6.63,4,6.5,4    C6.22,4,6,4.22,6,4.5v7C6,11.78,6.22,12,6.5,12c0.13,0,0.24-0.05,0.33-0.13c0,0,0,0,0,0l4-3.5l0,0C10.93,8.28,11,8.15,11,8z\"/>\n\t</g>\n</g>\n</svg>");
};
var getHamburgerImage = function getHamburgerImage(fill, color) {
  return "url(data:image/svg+xml;base64," + btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" fill=\"" + fill + "\"><g stroke=\"" + color + "\" stroke-width=\"2.9\" ><path d=\"M14 15.7h14.4\"/><path d=\"M14 21.4h14.4\"/><path d=\"M14 27.1h14.4\"/></g></svg>") + ")";
};
var StyledSortableTree = (0, _styledComponents["default"])(_reactSortableTree["default"]).withConfig({
  displayName: "TreeViewElement__StyledSortableTree",
  componentId: "sc-1jtm3p3-0"
})([".rst__rowSearchMatch,.rst__rowSearchFocus{outline:", ";}.rst__lineFullVertical::after,.rst__lineHalfVerticalTop::after,.rst__lineHalfVerticalBottom::after,.rst__lineChildren::after{background-color:", ";width:3px;}.rst__lineHalfHorizontalRight::before{background-color:", ";height:3px;}.rst__rowContents,.rst__rowContentsDragDisabled{border:none;box-shadow:none;background-color:", ";min-width:230px;}.rst__collapseButton{background-color:", ";background-image:", ";box-shadow:none;}.rst__expandButton{background-color:", ";background-image:", ";box-shadow:none;}.rst__moveHandle{background:", ";border:none;box-shadow:none;}.rst__rowWrapper{padding:10px 10px 2px 0;}"], function (props) {
  return "solid 3px " + props.theme.PlantTwinSearchMatchingHighlightColor;
}, function (props) {
  return props.theme.PlantTwinLineBackground;
}, function (props) {
  return props.theme.PlantTwinLineBackground;
}, function (props) {
  return props.theme.PlantTwinDeviceBackground;
}, function (props) {
  return props.theme.PlantTwinAccordionColor;
}, function (props) {
  return "url(\"" + getCollapseBgImage(props.theme.PlantTwinCollapseFillColor) + "\")";
}, function (props) {
  return props.theme.PlantTwinAccordionColor;
}, function (props) {
  return "url(\"" + getExpandBgImage(props.theme.PlantTwinExpandFillColor) + "\")";
}, function (props) {
  return props.theme.PlantTwinDeviceBackground + " " + getHamburgerImage(props.theme.PlantTwinDeviceBackground, props.theme.PlantTwinCollapseFillColor) + " no-repeat center";
});

/**
 * Tree View
 * @returns {*}
 * @constructor
 */
function TreeViewElement(props) {
  var mode = props.mode,
    treeData = props.treeData,
    setTreeData = props.setTreeData,
    canDrag = props.canDrag,
    canDrop = props.canDrop,
    searchQuery = props.searchQuery,
    searchFocusOffset = props.searchFocusOffset,
    rowHeight = props.rowHeight;
  var isEditMode = mode === "edit";
  var customSearchMethod = function customSearchMethod(_ref) {
    var node = _ref.node,
      searchQuery = _ref.searchQuery;
    return searchQuery && node.title.props.name.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
  };
  var treeProps = {
    getNodeKey: function getNodeKey(_ref2) {
      var node = _ref2.node;
      return node.uuid;
    },
    treeData: treeData,
    onChange: function onChange(updatedTree) {
      setTreeData(updatedTree);
    },
    canDrag: isEditMode ? canDrag || function () {
      return true;
    } : function () {
      return false;
    },
    canDrop: isEditMode ? canDrop || function () {
      return true;
    } : function () {
      return false;
    },
    isVirtualized: true,
    onMoveNode: function onMoveNode(_ref3) {
      var node = _ref3.node,
        path = _ref3.path;
      node.path = path.join(".");
    },
    searchQuery: searchQuery,
    searchFocusOffset: searchFocusOffset,
    searchMethod: customSearchMethod,
    rowHeight: rowHeight
  };
  return /*#__PURE__*/_react["default"].createElement(StyledSortableTree, treeProps);
}